import { render } from "./NotFound.vue?vue&type=template&id=6f4b1030&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=6f4b1030&lang=scss&scoped=true"

import exportComponent from "../../../../MemberPortal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4b1030"]])

export default __exports__